import type { WithContext, WebSite } from 'schema-dts'
import DEFAULT_META_TAGS from '@/constants/meta'

const FlightSchemaMarkup: WithContext<WebSite> = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: 'https://www.priceline.com/flights',
  name: 'Priceline',
  description: DEFAULT_META_TAGS.description.flights
} as const

export default FlightSchemaMarkup
